import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDiscussReview } from "../../hooks/community/useDiscussReview";
import { useResourceUpload } from "../../hooks/community/useResourceUpload";
import { LoaderOverlay } from "../../hooks/loader/LoaderOverlay";
import { CommunityDetails } from "./components/CommunityDetails";
import { CommunityMedia } from "./components/CommunityMedia";
import { CommunityDiscussComments } from "./models/CommunityDiscussComments";

export const CommunityDetailsPage = () => {
    const { id } = useParams() as any;
    const history = useHistory();
    const { loading, details, addComment, react, error } = useDiscussReview(id);
    const { files, insertFile, removeFile, processFiles } = useResourceUpload(id);
    const [replySelect, setReplySelect] = useState<CommunityDiscussComments | null>(null);

    useEffect(() => {
        if(!!error)
            return history.replace('/community');
    }, [error]);

    useEffect(() => {
        document.body.classList.add('community-wrapper')
        return () => document.body.classList.remove('community-wrapper')
    }, []);

    return (
        <>
            <LoaderOverlay visible={loading} message={'Loading...'} />
            <div className="d-flex flex-row flex-wrap justify-content-center" style={{ marginTop: 'var(--External-Marging, 60px)', gap: 'var(--External-Marging, 60px)' }}>
                { details && (
                    <>
                        <CommunityDetails 
                            author={details.author.username}
                            avatar={details.author.avatar}
                            comments={details.comments}
                            content={details.content}
                            tags={details.tags}
                            title={details.topic}
                            onSendComment={(value, reply) => addComment(value, reply?.id, processFiles, () => setReplySelect(null))}
                            onReactComment={(c) => react(c.id)}
                            onAddFile={insertFile}
                            onRemoveFile={(f) => removeFile(f.file)}
                            files={files}
                            replySelect={replySelect}
                            setReplySelect={setReplySelect}
                        />
                        <CommunityMedia mediafiles={details.mediafiles} />
                    </>
                )}
            </div>
        </>
    )
}